/* eslint-disable react/jsx-key */
import React, { ReactNode, useContext, useState } from "react";
import { PDFDesignerProviderValue, PhoenixPDFsDesignerContext } from "./PhoenixPdfDesignerContext";
import { PdfDisplayControl } from "interfaces/Phoenix.FormsDesigner.Models";
import PNXLabel from "components/PhoenixFormsV4/Controls/PNXLabel";
import { classes } from "components/Utility";
import IconButton from "components/Shared/IconButton";
import { stopPropagationPreventDefault, stopPropagationPreventDefaultNoFn } from "tools/clickEvents";
import { Button } from "components/Shared";
import ReorderableGrid, { ReorderableItem } from "components/Shared/ReorderableGrid";

interface DesignerPdfControlProps {
  className?: string;
  label: PdfDisplayControl;
  parentSection?: PdfDisplayControl;
};

export const reorderLabelHandle = "reorder-question-handle";
export const reorderNestedLabelHandle = "reorder-nested-question-handle";

const DesignerPdfControl = ({ className, label, parentSection }: DesignerPdfControlProps) => {
  const context = useContext<PDFDesignerProviderValue>(PhoenixPDFsDesignerContext);
  const [isGroupRepeatCollapsed, setIsGroupRepeatCollapsed] = useState<boolean>(false);
  
  let controlPreview: ReactNode;
  let isGroupOrRepeat = false; 


  switch (label.type) {
    
    case "Label":
      controlPreview = null;
      break;

    case "TableCell":
      controlPreview = null;
      break;

    case "TableArea":
      controlPreview = null;
      break;

    case "SubSectionGroup-Full":
      isGroupOrRepeat = true;

      let controls = label.children.reduce((acc, c, i) => {

        acc.push({
          id: c.id,
          node: <DesignerPdfControl 
                  key={c.id}
                  label={c}
                  parentSection={label}
                  className={(!context.isShowingHidden && c.properties.hide) && "hide-element"}
                />,
        });
        return acc;
      }, [] as ReorderableItem[]);

      controlPreview = label.children.length === 0 ? 
        <Button
          primary
          onClick={() => context.editFns.addNewLabel({control : label})}
          className="add-question-to-group"
        >
          Add New Label
        </Button>
        :
        <ReorderableGrid
          className="section-controls repeat"
          items={controls}
          handleSelector={`.${reorderLabelHandle}`}
          onReorder={ids => context.editFns.reorderChildren( label, ids)}
        />;
      break;
  }

  const divClassName =
    classes(
      "designer-question formcontrol",
      className,
      context?.selectedLabel?.id === label.id && "selected-question",
      label.type === "SubSectionGroup-Full" && "repeat-control"
    );

  const controlWithoutPreview: ReactNode[] = [
    isGroupOrRepeat && <IconButton icon="keyboard_arrow_down" className={classes("md-collapser", !isGroupRepeatCollapsed && "md-collapser--flipped")} onClick={stopPropagationPreventDefault(() => setIsGroupRepeatCollapsed(!isGroupRepeatCollapsed))}/>,
    <IconButton icon="reorder" className={reorderLabelHandle} onClick={stopPropagationPreventDefaultNoFn} />,
    <IconButton icon="input" onClick={stopPropagationPreventDefault(() => context.editFns.moveToSection({controlId: label.id, sourceSection: parentSection, destinationSectionId: null}))}  />,
    <IconButton icon="add" onClick={stopPropagationPreventDefault(() => context.editFns.addNewLabel({ modifierLabelId: label.id, control: parentSection }))} />,
    <IconButton icon="delete" onClick={stopPropagationPreventDefault(() => context.editFns.deleteLabel(label.id))} />,
    <div className="designer-control-label"><PNXLabel>{label.name}</PNXLabel></div>,
  ].filter(Boolean);

  return (
    <div className={divClassName} onClick={stopPropagationPreventDefault(() => context.setSelectedLabel(label))}>
      {isGroupOrRepeat ? 
      <> {/* group / repeats */}
        <div className="control-title">{controlWithoutPreview}{isGroupRepeatCollapsed}</div>
        {!isGroupRepeatCollapsed && <div className="control-preview">{controlPreview}</div>}
      </>
      :
      <> {/* single controls */}
        {controlWithoutPreview}
        {<div className="control-preview">{controlPreview}</div>}
      </>}
    </div>
  );
};

export default DesignerPdfControl;
